module.exports = __webpack_public_path__ + "img/nodata.a8eb1cb5.png";